import { CircleUserIcon } from 'lucide-react';

const AccountIcon = ({ initial }: { initial?: string }) => {
  if (initial) {
    return (
      <>
        <span className="flex h-7 w-7 items-center justify-center rounded-full bg-[#F2F2F2] text-xs font-semibold uppercase text-gray-700">
          {initial}
        </span>
      </>
    );
  }

  return <CircleUserIcon className="h-[22px] w-[22px]" strokeWidth={1.7} />;
};

export default AccountIcon;
